var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RefinanceWizard',_vm._b({},'RefinanceWizard',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }